import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { publicAPI } from '../../lib/api';
import { BookOpen, ArrowRight, Search } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Badge } from '../../components/ui/badge';

export default function DirectoryPage() {
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    publicAPI.getDirectoryCategories()
      .then(r => setCategories(r.data))
      .finally(() => setLoading(false));
  }, []);

  const filtered = search
    ? categories.filter(c => c.name.toLowerCase().includes(search.toLowerCase()))
    : categories;

  return (
    <>
      <Helmet>
        <title>Sanayi Rehberi | Endustriyel Uretim Makaleleri</title>
        <meta name="description" content="CNC isleme, lazer kesim, kalip uretimi ve endustriyel uretim konularinda kapsamli rehber makaleler." />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": "Sanayi Rehberi",
          "description": "Turkiye genelinde endustriyel uretim firmalari rehberi"
        })}</script>
      </Helmet>

      <section className="bg-[hsl(221,83%,22%)] text-white py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-semibold mb-3" data-testid="directory-title">Sanayi Rehberi</h1>
          <p className="text-blue-100 max-w-2xl">Endustriyel uretim konularinda kapsamli rehber makaleler ve teknik bilgiler.</p>
          <div className="mt-6 relative max-w-md">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-blue-200" />
            <Input
              placeholder="Kategori ara..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              className="pl-10 bg-white/10 border-white/20 text-white placeholder:text-blue-200"
              data-testid="directory-search"
            />
          </div>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="flex items-center justify-center h-32"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[hsl(221,83%,22%)]"></div></div>
          ) : filtered.length === 0 ? (
            <p className="text-center text-muted-foreground py-12">Kategori bulunamadi.</p>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map(cat => (
                <Link key={cat.id} to={`/sanayi-rehberi/${cat.slug}`}>
                  <Card className="h-full hover:shadow-md transition-shadow" data-testid={`dir-cat-${cat.slug}`}>
                    <CardContent className="p-6">
                      <BookOpen className="h-10 w-10 text-[hsl(221,83%,22%)] mb-4" />
                      <h2 className="text-xl font-semibold mb-2">{cat.name}</h2>
                      <p className="text-sm text-muted-foreground mb-4 leading-relaxed">{cat.description}</p>
                      <div className="flex items-center justify-between">
                        {cat.article_count > 0 && (
                          <Badge variant="secondary">{cat.article_count} makale</Badge>
                        )}
                        <span className="text-sm font-medium text-[hsl(221,83%,22%)] flex items-center gap-1">
                          Makaleleri Oku <ArrowRight className="h-4 w-4" />
                        </span>
                      </div>
                    </CardContent>
                  </Card>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
